/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SbSharedRelatedItems_searchBrowse = {|
  +relatedItems: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +serviceId: ?string;
      |};
    |}>;
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRelatedItems_searchBrowse",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedItemTile_searchBrowse",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": "relatedItems",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 12,
          "type": "Int"
        },
        {
          "kind": "Literal",
          "name": "seller",
          "value": "INCLUDE",
          "type": "seller"
        }
      ],
      "concreteType": "searchBrowseMoreLikeThisConnection",
      "name": "thinBrowseRelatedItems",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "searchBrowseMoreLikeThisEdge",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "Item",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "SbSharedItemTile_item",
                  "args": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "serviceId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "thinBrowseRelatedItems{\"first\":12,\"seller\":\"INCLUDE\"}"
    }
  ],
  "type": "SearchBrowseQueryConnection"
};

module.exports = fragment;
